<template>
    <div class="page">
        <!-- 我的 -->
        <div class="b1" data-flex="cross:center" >
            <div class="img-box">
                <img :src="infodata.headimg" alt="" v-if="infodata.headimg">
            </div>
            <div class="name-box">
                <p>{{ infodata.nickname }}</p>
                <!-- <div class="role" data-flex="cross:center">
                    <img src="../../assets/images/m-09.png" alt="">
                    <p class=" mr-5">{{ profile.memberLevel == 2 ? '技术员' : '用户' }}</p>
                </div> -->
            </div>
        </div>

        <!-- <div class="b3">
            <router-link to="/my/order" class="tit">
                <span>进度查询</span>
            </router-link>
            <div class="grids" data-flex="main:center cross:center">
                <router-link to="/my/order" class="grid-item" hover-class="none" data-flex-box="0"
                    data-flex="dir:top cross:center">
                    <img src="../../assets/images/m-01.png" alt="">
                    <span data-flex-box="0">全部</span>
                </router-link>
                <router-link to="/my/order?filterType=1" class="grid-item" hover-class="none" data-flex-box="0"
                    data-flex="dir:top cross:center">
                    <img src="../../assets/images/m-02.png" alt="">
                    <span data-flex-box="0">待服务</span>
                    <div v-if="count.count1 > 0">{{ count.count1 > 99 ? '99+' : count.count1 }}</div>
                </router-link>
                <router-link to="/my/order?filterType=2" class="grid-item" hover-class="none" data-flex-box="0"
                    data-flex="dir:top cross:center">
                    <img src="../../assets/images/m-03.png" alt="">
                    <span data-flex-box="0">待评价</span>
                    <div v-if="count.count2 > 0">{{ count.count2 > 99 ? '99+' : count.count2 }}</div>
                </router-link>
                <router-link to="/my/order?filterType=2" class="grid-item" hover-class="none" data-flex-box="0"
                    data-flex="dir:top cross:center">
                    <img src="../../assets/images/m-04.png" alt="">
                    <span data-flex-box="0">已完成</span>
                </router-link>
            </div>
        </div> -->

        <div class="b2">
            <router-link to="/my/qrcode" data-flex-box="0">
                <div data-flex="cross:center">
                    <img class="b2-icon" src="../../assets/images/wdewm@2x.png" alt="">
                    <p data-flex-box="1">我的二维码</p>
                    <img class="right-img" src="../../assets/images/left@2x.png" alt="">
                </div>
            </router-link>
            
            <router-link to="/my/profile" data-flex-box="0">
                <div data-flex="cross:center">
                    <img class="b2-icon" src="../../assets/images/grzl@2x.png" alt="">
                    <p data-flex-box="1">个人资料</p>
                    <img class="right-img" src="../../assets/images/left@2x.png" alt="">
                </div>
            </router-link>

            <router-link to="/home/AddOk" data-flex-box="0" v-show="havesqrData">
                <div data-flex="cross:center">
                    <img class="b2-icon" src="../../assets/images/m-08.png" alt="">
                    <p data-flex-box="1">我的申报</p>
                    <img class="right-img" src="../../assets/images/left@2x.png" alt="">
                </div>
            </router-link>

            <router-link to="/home/application" data-flex-box="0" v-show="!havesqrData">
                <div data-flex="cross:center">
                    <img class="b2-icon" src="../../assets/images/m-08.png" alt="">
                    <p data-flex-box="1">我的申请</p>
                    <img class="right-img" src="../../assets/images/left@2x.png" alt="">
                </div>
            </router-link>

            <router-link to="/my/sbjl" data-flex-box="0" v-show="infodata.declarant == 1">
                <div data-flex="cross:center">
                    <img class="b2-icon" src="../../assets/images/sqjl@2x.png" alt="">
                    <p data-flex-box="1">申请记录</p>
                    <img class="right-img" src="../../assets/images/left@2x.png" alt="">
                </div>
            </router-link>
            <!-- <div data-flex="cross:center" @click="remClear">
                <img class="icon" src="../../assets/images/left.png" alt="">
                <p data-flex-box="1">清除缓存</p>
                <img src="../../assets/images/left.png" alt="">
            </div> -->
        </div>



        
        <van-tabbar v-model="active" style="position: fixed; bottom: 0;">
            <van-tabbar v-model="active" active-color="#FD4A46">
                <van-tabbar-item @click="tabsTo(1)">
                    <span>预约</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/home.png" alt="">
                        <img v-else src="../../assets/images/t-01.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item @click="tabsTo(2)">
                    <span>申报</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/sq1.png" alt="">
                        <img v-else src="../../assets/images/sq0.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item icon="search" @click="tabsTo(3)">
                    <span>我的</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/my.png" alt="">
                        <img v-else src="../../assets/images/t-02.png" alt="">
                    </template>
                </van-tabbar-item>
            </van-tabbar>
        </van-tabbar>

    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Tabbar, TabbarItem,Toast  } from 'vant'
// import MgPopup from '@/components/common/mg-popup'

export default {
    name:"myIndex",
    mixins: [mix1],
    components: {
        Button,
        NumberKeyboard,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem
    },
    data() {
        return {
            active: 2,
            count: {},
            profile: {},
            infodata:{
                headimg:""
            },
            sqrData:{},//是否已经申请过，如是，有数据
            havesqrData:false,//是否申请过

            wtgData:{},//是否已经预约过且未通过，如是，有数据
            havewtgData:false,//是否有未通过预约
        }
        
    },
    methods: {
        // 是否成为申请人的数据
        async getSqData(){
            uiShowLoading();
            const promise = this.apiGet("declaration.postForm");
            let apiResult = null;
            try {
                apiResult = await promise;
            } catch (ex) {
                apiResult = null;
            }
            if (this.isEmpty(apiResult)) {
                return;
            }
            console.log("getSqData:",apiResult);
            if(apiResult.obj.id){
            this.sqrData = apiResult.obj;
            }
            
            console.log("是否申请人提交过数据:",this.sqrData);
            if(this.sqrData.id){
            console.log("this.sqrData.id",this.sqrData.id);
            this.havesqrData = true;
            }
            uiHideLoading();
            this.getyy();
        },

        // 是否有未通过的预约
        async getyy(){
        uiShowLoading();
            const promise = this.apiGet("yy.state");
            let apiResult = null;
            try {
                apiResult = await promise;
            } catch (ex) {
                apiResult = null;
            }
            if (this.isEmpty(apiResult)) {
                return;
            }
            console.log("getyy:",apiResult);
            if(apiResult.obj.id){
            this.wtgData = apiResult.obj;
            }
            if(this.wtgData.id){
            console.log("this.wtgData.id",this.wtgData.id);
            this.havewtgData = true;
            }
            console.log("是否有未通过的预约:",this.wtgData);
            uiHideLoading();
        },

        async orderCount() {
            const promise = this.apiGet('order.count')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.count = apiResult.obj
        },

        tabsTo(type) {
            if (type == 1) {
                this.$router.push("/");
            } else if (type == 2) {
                if(this.havewtgData){
                this.$router.push("/declare/declareOk");
                }
                else if(!this.havewtgData){
                if(!this.havesqrData){
                this.$router.push("/home/application");
                }else{
                    if(this.infodata.declarant == 1){
                    this.$router.push("/declare/index");
                    }else if(this.infodata.declarant == 0){
                    this.$router.push("/home/addOk");
                    }else if(this.infodata.declarant == 2){
                        Toast('申报功能被冻结');
                    }
                }
                }
            } else {
                this.$router.push("/my/index");
            }
        },

        async getProfile(id) {
            const promise = this.apiGet('fans.profile')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.profile = apiResult.obj
        },

        remClear() {
            localStorage.clear();
            location.reload();
        },

        async getUserInfo(){
            const promise = this.apiGet('my.userInfo')

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            if (this.isEmpty(apiResult)) {
                return
            }
            console.log("apiResult",apiResult);
            this.infodata = apiResult.obj
            console.log("this.infodata=>",this.infodata);
        }
    },
    mounted() {

    },
    created() {
        // this.orderCount()
        // this.getProfile()
        this.getUserInfo()
        this.getSqData()
    }
}
</script>

<!-- <style lang="less" scoped>
.van-tabbar-item--active {
    color: #FD4A46;
}

.van-tabbar--fixed {
    height: 100px;
}

.van-hairline--top-bottom {
    padding: 0 50px;
    box-sizing: border-box;
}

.van-swipe__indicator {
    width: 10px;
    height: 10px;
}

.list {
    .van-card {
        padding-bottom: 30px;
        background: #fff;

        .van-card__thumb {
            width: 300px;
            height: 150px;
        }

        .van-card__content {
            .van-card__title {
                font-size: 13px;
                color: #333;
                line-height: 24px;
            }

            .van-card__price {
                font-size: 15px;
                line-height: 14px;
                color: #e84115;
            }
        }
    }
}
</style> -->
<style lang="less" scoped>
.page {
    padding-bottom: 100px;
    .b1 {
        margin: 0 auto;
        width: 750px;
        height: 240px;
        background-color: #FD4A46;
        .img-box{
            width: 100px;
            height: 100px;
            border: 2px solid #FFFFFF;
            border-radius: 50%;
            margin-left: 36px;
            img {
                width: 100px;
                height: 100px;
                border-radius: 50%;
            }
        }
        .name-box{
            margin-left: 24px;
            height: 46px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 46px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
        // .role {
        //     margin-top: 10px;
        //     background: #205CFF;
        //     border-radius: 100px;
        //     padding: 0px 5px;
        //     // max-width: 120px;
        //     display: inline-flex;

        //     img {
        //         width: 30px;
        //         height: 30px;
        //         margin-right: 5px;
        //         padding: 5px;
        //     }

        //     p {
        //         font-size: 12px;
        //         color: #fff;
        //         font-weight: normal;
        //     }
        // }
    }
    .b2 {
        background: #fff;
        margin: 0 auto;
        width: 710px;
        margin-top: 24px;
        div {
            margin: 0 auto;
            width: 710px;
            height: 100px;
            border-bottom: solid 1px #eee;
            .b2-icon{
                width: 40px;
                height: 40px;
                margin-left: 24px;
            }
            p {
                margin-left: 20px;
                font-size: 14px;
                color: #303D50;
                font-weight: bold;
            }
            .right-img{
                width: 24px;
                height: 24px;
                margin-right: 26px;
            }
        }
    }

    // .b3 {
    //     width: 690px;
    //     margin: 0 auto;
    //     background: #fff;
    //     border-radius: 10px;
    //     margin-top: 0;
    //     box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    //     margin-bottom: 30px;

    //     .tit {
    //         padding: 24px 20px;
    //         display: inline-block;

    //         span:nth-child(1) {
    //             font-size: 15px;
    //             color: #000;
    //             font-weight: bold;
    //         }
    //     }

    //     .icon-jiantouyou {
    //         font-size: 16px;
    //         color: #999;
    //     }

    //     .grids {
    //         padding: 20px 0;

    //         .grid-item {
    //             position: relative;
    //         }

    //         span {
    //             font-size: 13px;
    //             color: #000;
    //             margin-top: 14px;
    //             font-weight: bold;
    //         }

    //         view {
    //             background: #fff;
    //             position: absolute;
    //             top: -10px;
    //             left: 80px;
    //             padding: 2px 8px;
    //             box-sizing: border-box;
    //             font-size: 20px;
    //             color: #fe946e;
    //             line-height: 24px;
    //             text-align: center;
    //             border-radius: 100px;
    //             border: solid 1px #fe946e;
    //             box-sizing: border-box;

    //         }
    //     }

    //     .grid-item {
    //         width: 25%;
    //         position: relative;

    //         img {
    //             width: 80px;
    //             height: 80px;
    //         }

    //         div {
    //             background: #EE6D07;
    //             padding: 100px;
    //             width: 30px;
    //             padding: 0;
    //             border-radius: 100px;
    //             position: absolute;
    //             right: 40px;
    //             top: -2px;
    //             text-align: center;
    //             line-height: 30px;
    //             color: #fff;
    //             font-size: 12px;
    //         }
    //     }
    // }

}
</style>